module.exports = __webpack_public_path__ + "img/Airbnb-Working-From-Office-Desk2-scaled.8d5d00ce.jpg";